import React from "react";

import { mdiCreditCardOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";

import { TypeEnum } from "@/src/api/ProjectAPI.types";

import { MENU_ICON_SIZE } from "./Menu";
import MenuItem from "./MenuItem";
import SubMenu from "./SubMenu";
import useAbility from "../../hooks/useAbility";
import { PROJECTS_ROUTE } from "../routes/routes";

import type { JSX } from "react";

import type { AppState } from "../../reducers";

function OffersSubMenu(): JSX.Element {
  const { t } = useTranslation("editor-menu");
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { canAccess } = useAbility();

  const orgaConfig = useSelector(
    (state: AppState) => state.fetchReducer.orga_config,
  );
  const currentProject = useSelector(
    (state: AppState) => state.architectureReducer.project,
  );

  const isEDU = currentProject?.type === TypeEnum.Edu;

  const { project: canAccessProject } = canAccess(
    orgaConfig.data?.organization_options,
  );
  return (
    <SubMenu
      icon={<Icon path={mdiCreditCardOutline} size={MENU_ICON_SIZE} />}
      label={t("offerManagement")}
    >
      {canAccessProject.advertisingsSponsorings ? (
        <MenuItem
          label={t("advertising")}
          component={
            <NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/advertisings`} />
          }
        />
      ) : null}
      {isEDU ? (
        <MenuItem
          label={t("edus")}
          component={
            <NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/institutions`} />
          }
        />
      ) : null}
      <MenuItem
        component={<NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/offers`} />}
        label={t("offers")}
      />
      {!isEDU && canAccessProject.freeCopies ? (
        <MenuItem
          label={t("freecopies")}
          component={
            <NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/freecopy`} />
          }
        />
      ) : null}
      {!isEDU && canAccessProject.gifts ? (
        <MenuItem
          component={<NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/gift`} />}
          label={t("gifts")}
        />
      ) : null}
    </SubMenu>
  );
}

export default OffersSubMenu;
